import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { id: "contactTab" }
const _hoisted_2 = { class: "ml-3 mr-3" }
const _hoisted_3 = { class: "pl-5 pt-4" }
const _hoisted_4 = { class: "ml-3 mr-3" }
const _hoisted_5 = { class: "pl-5 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_CountdownTimer = _resolveComponent("CountdownTimer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[9] || (_cache[9] = _createTextVNode(" Address ")),
      (!_ctx.isHiringmanager)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            loading: _ctx.saveAddressLoading,
            color: "accent",
            dark: "",
            class: "ml-3 action-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newAddress()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-plus")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses, (address, index) => {
      return (_openBlock(), _createBlock(_component_v_card, {
        class: _normalizeClass(_ctx.getClass(address) + ' mt-2 pb-3'),
        key: `address-${index}`,
        disabled: _ctx.saveAddressLoading
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  lg: "7",
                  md: "7",
                  sm: "12",
                  xs: "12",
                  class: "pb-0"
                }, {
                  default: _withCtx(() => [
                    (address.Id)
                      ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                          default: _withCtx(() => [
                            (address.VerifiedOn)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "pr-2",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("mdi-check-circle")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode("Address " + _toDisplayString(_ctx.addresses.some((c) => !c.Id) ? index : index + 1) + " Verified", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (address.IsDefault && !address.VerifiedOn)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "pr-2",
                                      color: "error"
                                    }, {
                                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                                        _createTextVNode("mdi-close-circle")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode("Address " + _toDisplayString(_ctx.addresses.some((c) => !c.Id) ? index : index + 1) + " Unverified", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (!address.IsDefault && !address.VerifiedOn)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Address " + _toDisplayString(_ctx.addresses.some((c) => !c.Id) ? index : index + 1), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (!address.Id)
                      ? (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                          default: _withCtx(() => [
                            (!_ctx.isHiringmanager)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 0 }, {
                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode("New address")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      lg: "5",
                      md: "5",
                      sm: "12",
                      xs: "12",
                      class: "text-right"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          small: "",
                          icon: "mdi-pencil-outline",
                          class: "mr-3 mt-5",
                          onClick: ($event: any) => (_ctx.editAddress(index))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          small: "",
                          icon: "mdi-delete",
                          class: "mr-5 mt-5",
                          onClick: ($event: any) => (_ctx.removeAddress(index))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_for: true,
                  ref: 'frmAddress' + index,
                  "lazy-validation": "",
                  class: "form-inputs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              dense: "",
                              outlined: "",
                              loading: _ctx.isCountryLoading,
                              disabled: !address.IsEditing || _ctx.isCountryLoading,
                              rules: [_ctx.validations.required],
                              showRequired: "",
                              items: _ctx.countries,
                              "item-title": "Name",
                              "item-value": "Id",
                              onChange: ($event: any) => (_ctx.filterCities(index)),
                              label: "Country",
                              placeholder: "Country",
                              modelValue: address.Country,
                              "onUpdate:modelValue": [($event: any) => ((address.Country) = $event), ($event: any) => (_ctx.resetCity(index))]
                            }, null, 8, ["loading", "disabled", "rules", "items", "onChange", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextField, {
                              dense: "",
                              disabled: !address.IsEditing,
                              rules: [_ctx.validations.required],
                              showRequired: "",
                              modelValue: address.StreetAddress,
                              "onUpdate:modelValue": ($event: any) => ((address.StreetAddress) = $event),
                              outlined: "",
                              label: "Street Address",
                              placeholder: "Street Address"
                            }, null, 8, ["disabled", "rules", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AutoCompleteField, {
                              dense: "",
                              outlined: "",
                              loading: _ctx.isCityLoading,
                              disabled: !address.IsEditing || _ctx.isCityLoading,
                              rules: [_ctx.validations.required],
                              showRequired: "",
                              items: address.Cities,
                              "item-title": "name",
                              "item-value": "name",
                              label: "City / Suburb",
                              modelValue: address.Suburb,
                              "onUpdate:modelValue": ($event: any) => ((address.Suburb) = $event)
                            }, null, 8, ["loading", "disabled", "rules", "items", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextField, {
                              dense: "",
                              disabled: !address.IsEditing,
                              showRequired: "",
                              rules: [_ctx.validations.required],
                              modelValue: address.State,
                              "onUpdate:modelValue": ($event: any) => ((address.State) = $event),
                              outlined: "",
                              placeholder: "State / Province / Region",
                              label: "State / Province / Region"
                            }, null, 8, ["disabled", "rules", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextField, {
                              disabled: !address.IsEditing,
                              dense: "",
                              rules: [_ctx.validations.required],
                              showRequired: "",
                              modelValue: address.Postcode,
                              "onUpdate:modelValue": ($event: any) => ((address.Postcode) = $event),
                              outlined: "",
                              placeholder: "Postcode",
                              label: "Postcode"
                            }, null, 8, ["disabled", "rules", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextField, {
                              placeholder: "Title",
                              label: "Title",
                              disabled: !address.IsEditing,
                              rules: [_ctx.validations.required],
                              showRequired: "",
                              outlined: "",
                              dense: "",
                              modelValue: address.Name,
                              "onUpdate:modelValue": ($event: any) => ((address.Name) = $event),
                              "persistent-hint": "",
                              hint: "For example: Home, Office and etc"
                            }, null, 8, ["disabled", "rules", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4",
                          class: "align-content-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              disabled: !address.IsEditing,
                              class: "mt-0",
                              label: "Default address",
                              modelValue: address.IsDefault,
                              "onUpdate:modelValue": ($event: any) => ((address.IsDefault) = $event),
                              "hide-details": ""
                            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        (address.IsEditing && !_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              class: "pt-5 align-self-center text-right",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.cancelAddressEditing(index)),
                                  class: "secondary_btn mr-4"
                                }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode("Cancel")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  class: "primary_btn",
                                  loading: address.Loading,
                                  onClick: ($event: any) => (_ctx.saveAddress(address))
                                }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode("Save")
                                  ])),
                                  _: 2
                                }, 1032, ["loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (!address.IsEditing && !address.ShowSendCodeButton && !address.ShowVerificationField && !_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              class: "pt-5 align-self-center text-right",
                              cols: "12",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "primary_btn",
                                  disabled: address.IsDefault,
                                  loading: address.Loading,
                                  onClick: ($event: any) => (_ctx.setAddressAsDefault(index))
                                }, {
                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createTextVNode("Set as default")
                                  ])),
                                  _: 2
                                }, 1032, ["disabled", "loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    (!_ctx.isHiringmanager && address.ShowSendCodeButton)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "pt-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "4",
                              class: "align-self-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_vue_recaptcha, {
                                      sitekey: _ctx.siteKey,
                                      onVerify: _ctx.validateAddressRecaptcha,
                                      onExpire: _ctx.onAddressRecaptchaExpired,
                                      ref_for: true,
                                      ref: "addressRecaptcha"
                                    }, null, 8, ["sitekey", "onVerify", "onExpire"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "8",
                              class: "align-self-center text-right"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.cancelAddressEditing(index)),
                                  class: "secondary_btn mr-4"
                                }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode("Cancel")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  disabled: !_ctx.addressRecaptchaVerified,
                                  loading: _ctx.addressSendingCode,
                                  class: "accent",
                                  onClick: ($event: any) => (_ctx.sendAddressCode(address))
                                }, {
                                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                                    _createTextVNode("Send Code")
                                  ])),
                                  _: 2
                                }, 1032, ["disabled", "loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1536),
                (address.ShowVerificationField)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      align: "center",
                      class: "pl-3 pb-5"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_form, {
                              key: 0,
                              ref_for: true,
                              ref: 'frmVerifyAddress' + index,
                              "lazy-validation": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "pb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "input-label" }, " Verification Code ", -1)),
                                    _createVNode(_component_v_text_field, {
                                      dense: "",
                                      modelValue: address.VerificationCode,
                                      "onUpdate:modelValue": ($event: any) => ((address.VerificationCode) = $event),
                                      rules: [_ctx.validations.required, _ctx.validations.verificationCodeMinLength],
                                      onKeypress: _ctx.NumbersOnly,
                                      outlined: "",
                                      placeholder: "Verification Code"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "onKeypress"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1536))
                          : _createCommentVNode("", true),
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12",
                              lg: "2",
                              md: "3",
                              sm: "4",
                              xs: "4",
                              class: "pt-9 align-self-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "secondary",
                                  loading: _ctx.addressVerifyBtnLoading,
                                  onClick: ($event: any) => (_ctx.verifyAddress(address))
                                }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode("Verify")
                                  ])),
                                  _: 2
                                }, 1032, ["loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          class: "pt-6",
                          cols: "12",
                          lg: "5",
                          md: "5",
                          sm: "5",
                          xs: "5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CountdownTimer, {
                              fromDate: address.EndTimerDate,
                              totalSeconds: 2592000,
                              addressVerificaion: true,
                              onFinishCountdownTimer: ($event: any) => (_ctx.finishAddressCountdownTimer(index))
                            }, null, 8, ["fromDate", "onFinishCountdownTimer"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            (address.Message)
              ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          lg: "8",
                          md: "8",
                          sm: "12",
                          xs: "12"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(address.Message), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1032, ["class", "disabled"]))
    }), 128)),
    _createVNode(_component_v_row, { class: "mt-7 mb-0 pl-4" }),
    _createElementVNode("div", null, [
      _cache[21] || (_cache[21] = _createTextVNode(" Phone numbers ")),
      (!_ctx.isHiringmanager)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            loading: _ctx.savePhoneNumberLoading,
            color: "accent",
            dark: "",
            class: "ml-3 action-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPhone()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode("mdi-plus")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phones, (phone, index) => {
      return (_openBlock(), _createBlock(_component_v_card, {
        class: _normalizeClass(_ctx.getClass(phone) + ' mt-2 pb-3'),
        key: `phone-${index}`,
        disabled: _ctx.savePhoneNumberLoading
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  lg: "7",
                  md: "7",
                  sm: "12",
                  xs: "12",
                  class: "pb-0"
                }, {
                  default: _withCtx(() => [
                    (phone.Id)
                      ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                          default: _withCtx(() => [
                            (phone.VerifiedOn)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "pr-2",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode("mdi-check-circle")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode("Phone number " + _toDisplayString(_ctx.phones.some((c) => !c.Id) ? index : index + 1) + " Verified", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (phone.IsDefault && !phone.VerifiedOn)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "pr-2",
                                      color: "error"
                                    }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createTextVNode("mdi-close-circle")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode("Phone number " + _toDisplayString(_ctx.phones.some((c) => !c.Id) ? index : index + 1) + " Unverified", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (!phone.IsDefault && !phone.VerifiedOn)
                              ? (_openBlock(), _createBlock(_component_v_btn, { key: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Phone number " + _toDisplayString(_ctx.phones.some((c) => !c.Id) ? index : index + 1), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (!phone.Id && !_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, null, {
                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                _createTextVNode("New phone number")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      lg: "5",
                      md: "5",
                      sm: "12",
                      xs: "12",
                      class: "text-right"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          small: "",
                          icon: "mdi-pencil-outline",
                          class: "mr-3 mt-5",
                          onClick: ($event: any) => (_ctx.editPhone(index))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          small: "",
                          icon: "mdi-delete",
                          class: "mr-5 mt-5",
                          onClick: ($event: any) => (_ctx.removePhone(index))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_for: true,
                  ref: 'frmPhone' + index,
                  "lazy-validation": "",
                  class: "form-inputs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          lg: "3",
                          md: "3",
                          sm: "12",
                          xs: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextField, {
                              disabled: !phone.IsEditing,
                              placeholder: "Title",
                              label: "Title",
                              rules: [_ctx.validations.required],
                              showRequired: "",
                              outlined: "",
                              dense: "",
                              modelValue: phone.Name,
                              "onUpdate:modelValue": ($event: any) => ((phone.Name) = $event),
                              "persistent-hint": "",
                              hint: "For example: Home, Office and etc"
                            }, null, 8, ["disabled", "rules", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          lg: "3",
                          md: "3",
                          sm: "12",
                          xs: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TextField, {
                              disabled: !phone.IsEditing,
                              dense: "",
                              rules: [_ctx.validations.required, _ctx.validations.phoneNumber],
                              showRequired: "",
                              outlined: "",
                              modelValue: phone.Phone,
                              "onUpdate:modelValue": ($event: any) => ((phone.Phone) = $event),
                              placeholder: "Mobile phone number",
                              label: "Mobile phone number"
                            }, null, 8, ["disabled", "rules", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          lg: "3",
                          md: "3",
                          sm: "12",
                          xs: "12",
                          class: "mt-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              disabled: !phone.IsEditing,
                              label: "Set as default phone number",
                              modelValue: phone.IsDefault,
                              "onUpdate:modelValue": ($event: any) => ((phone.IsDefault) = $event)
                            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        (phone.IsEditing && !_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              class: "pt-5 align-self-center text-right",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.cancelPhoneEditing(index)),
                                  class: "secondary_btn mr-4"
                                }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("Cancel")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  class: "primary_btn",
                                  loading: phone.Loading,
                                  onClick: ($event: any) => (_ctx.savePhone(phone))
                                }, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createTextVNode("Save")
                                  ])),
                                  _: 2
                                }, 1032, ["loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (!phone.IsEditing && !phone.ShowSendCodeButton && !phone.ShowVerificationField && !_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              class: "pt-5 align-self-center text-right",
                              cols: "12",
                              lg: "3",
                              md: "3",
                              sm: "12",
                              xs: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "primary_btn",
                                  disabled: phone.IsDefault,
                                  loading: phone.Loading,
                                  onClick: ($event: any) => (_ctx.setPhoneAsDefault(index))
                                }, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createTextVNode("Set as default")
                                  ])),
                                  _: 2
                                }, 1032, ["disabled", "loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    (phone.ShowSendCodeButton && !_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "pt-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              lg: "3",
                              md: "3",
                              sm: "12",
                              xs: "12",
                              class: "align-self-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_vue_recaptcha, {
                                      sitekey: _ctx.siteKey,
                                      onVerify: _ctx.validatePhoneRecaptcha,
                                      onExpire: _ctx.onPhoneRecaptchaExpired,
                                      ref_for: true,
                                      ref: "phoneRecaptcha"
                                    }, null, 8, ["sitekey", "onVerify", "onExpire"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "align-self-center text-right"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: ($event: any) => (_ctx.cancelPhoneEditing(index)),
                                  class: "secondary_btn mr-4"
                                }, {
                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                    _createTextVNode("Cancel")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  disabled: !_ctx.phoneRecaptchaVerified,
                                  loading: _ctx.phoneSendingCode,
                                  class: "primary_btn",
                                  onClick: ($event: any) => (_ctx.sendPhoneCode(phone))
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createTextVNode("Send Code")
                                  ])),
                                  _: 2
                                }, 1032, ["disabled", "loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1536),
                (phone.ShowVerificationField)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      align: "center",
                      class: "pl-3 pb-5"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_form, {
                              key: 0,
                              ref_for: true,
                              ref: 'frmVerifyPhone' + index,
                              "lazy-validation": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  lg: "12",
                                  md: "12",
                                  sm: "6",
                                  xs: "12",
                                  class: "pb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[30] || (_cache[30] = _createElementVNode("label", { class: "input-label" }, " Verification Code ", -1)),
                                    _createVNode(_component_v_text_field, {
                                      dense: "",
                                      modelValue: phone.VerificationCode,
                                      "onUpdate:modelValue": ($event: any) => ((phone.VerificationCode) = $event),
                                      rules: [_ctx.validations.required, _ctx.validations.verificationCodeMinLength],
                                      onKeypress: _ctx.NumbersOnly,
                                      outlined: "",
                                      placeholder: "Verification Code"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "onKeypress"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1536))
                          : _createCommentVNode("", true),
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "12",
                              lg: "2",
                              md: "3",
                              sm: "4",
                              xs: "4",
                              class: "pt-9 align-self-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "secondary",
                                  loading: _ctx.phoneNumberVerifyBtnLoading,
                                  onClick: ($event: any) => (_ctx.verifyPhone(phone))
                                }, {
                                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                                    _createTextVNode("Verify")
                                  ])),
                                  _: 2
                                }, 1032, ["loading", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          class: "pt-6",
                          cols: "12",
                          lg: "5",
                          md: "5",
                          sm: "5",
                          xs: "5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CountdownTimer, {
                              fromDate: phone.EndTimerDate,
                              totalSeconds: 120,
                              phoneNumberVerification: true,
                              onFinishCountdownTimer: ($event: any) => (_ctx.finishPhoneCountdownTimer(index))
                            }, null, 8, ["fromDate", "onFinishCountdownTimer"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            (phone.Message)
              ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          lg: "8",
                          md: "8",
                          sm: "12",
                          xs: "12"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_5, _toDisplayString(phone.Message), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1032, ["class", "disabled"]))
    }), 128)),
    (_ctx.showConfirm)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.showConfirm,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showConfirm) = $event)),
          "max-width": "500",
          onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.showConfirm = false), ["esc"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_confirm_dialog, {
              message: _ctx.confirmModel,
              onConfirm: _ctx.confirmRemove,
              onCancel: _ctx.cancel
            }, null, 8, ["message", "onConfirm", "onCancel"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showDefaultAddress)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 1,
          modelValue: _ctx.showDefaultAddress,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDefaultAddress) = $event)),
          "max-width": "500",
          onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.showDefaultAddress = false), ["esc"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_confirm_dialog, {
              message: _ctx.confirmModel,
              onConfirm: _ctx.confirmDefault,
              onCancel: _ctx.cancel
            }, null, 8, ["message", "onConfirm", "onCancel"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showDefaultPhone)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 2,
          modelValue: _ctx.showDefaultPhone,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDefaultPhone) = $event)),
          "max-width": "500",
          onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.showDefaultPhone = false), ["esc"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_confirm_dialog, {
              message: _ctx.confirmModel,
              onConfirm: _ctx.confirmDefault,
              onCancel: _ctx.cancel
            }, null, 8, ["message", "onConfirm", "onCancel"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}